import React from 'react'
import Kpippmdownload from '../../components/kpippmreportcomponents/Kpippmdownload'

function  Kpidownload({renderPageContent}) {
    return (
        <>
                        <Kpippmdownload renderPageContent={renderPageContent}/>
        </>
    )
}

export default  Kpidownload